import styled from "@emotion/styled";
import { PageHeader } from "components/Common/Page";

export const PeopleSettingLandingPageHeader = styled(PageHeader)(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	padding: "20px 32px",
	button: {
		alignItems: "center"
	},
	[theme.breakpoints.down("md")]: {
		alignItems: "flex-start",
		flexDirection: "column",
		gap: theme.project.layout.gap.large
	}
}));

export const PeopleContainer = styled.div(({ theme }) => ({
	margin: "12px",
	backgroundColor: theme.project.colors.backgroundColors.main,
	padding: "16px 20px",
	display: "flex",
	flexDirection: "column",
	gap: "16px"
}));
